
export interface CarouselState {
  deleteEvent: { path: string; index: number } | null;
  formEventChildData: {
    valid: boolean;
    elementVisual: any;
    dataTosaveVisual: any;
    size: any;
    index: number;
    docpath: string;
    action: any; 
  } | null;

}

export const initialState: CarouselState = {
  deleteEvent: null,
  formEventChildData: null,
};
